import { PropsWithChildren } from 'react'

import { Button, Divider, Flex, Popover, Space, Typography } from 'antd'
import { createStyles } from 'antd-style'

import { system } from '@eastcoal/common/config/system'

import { RouterLink } from '@eastcoal/router/components/Link'

import { GlobalAvatar } from '../GlobalAvatar'

import { GlobalHeaderProps } from './interface'
import wechatQrcode from './wechat_qrcode.jpg'

const useStyles = createStyles(({ token }) => ({
  container: {
    flexFlow: 'row nowrap',
    paddingBlock: token.paddingXS
  },
  qrcode: {
    width: 144,
    height: 144
  },
  serviceInfo: {
    color: token.colorTextDescription
  }
}))

export const GlobalHeader = ({
  showMallCenter = false,
  showMemberCenter = false,
  className,
  style,
  children
}: PropsWithChildren<GlobalHeaderProps>) => {
  const { cx, styles } = useStyles()

  return (
    <Flex
      align='middle'
      className={cx(styles.container, className)}
      justify='space-between'
      style={style}
    >
      <div>{children}</div>
      <Space separator={<Divider orientation='vertical' />}>
        <GlobalAvatar
          showMallCenter={showMallCenter}
          showMemberCenter={showMemberCenter}
        />
        <Popover
          arrow={false}
          placement='bottomLeft'
          content={
            <img
              alt='小程序二维码'
              className={styles.qrcode}
              src={wechatQrcode}
            />
          }
        >
          <Button size='small' type='text'>
            小程序版
          </Button>
        </Popover>
        <Typography.Text>我的收藏</Typography.Text>
        <RouterLink
          newtab
          hoverUnderline={false}
          to={system.router.memberBaseUrl}
          type='text'
        >
          消息中心
        </RouterLink>
        <Popover
          arrow={false}
          placement='bottomLeft'
          content={
            <Space align='start' orientation='vertical' size={2}>
              <div>
                <span className={styles.serviceInfo}>客服热线：</span>
                <span>021-26094528</span>
              </div>
              <div>
                <span className={styles.serviceInfo}>交易时间：</span>
                <span>08:30 — 17:00 </span>
              </div>
            </Space>
          }
        >
          <Button size='small' type='text'>
            客户服务
          </Button>
        </Popover>
      </Space>
    </Flex>
  )
}
